import type { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';

import ErrorOverlayWithRefetchButton from 'src/components/dashboard/DashboardPage/components/ErrorOverlayWithRefetchButton';

export const LOADING_DOUGHNUT_WIDGET_TEST_ID = 'loading-doughnut-widget';

interface DoughnutSkeletonProps {
  bigVersion: boolean;
  errorMsg?: string;
  refetch?: () => void;
}

const DoughnutSkeleton: FC<DoughnutSkeletonProps> = ({
  bigVersion,
  errorMsg,
  refetch,
}) => (
  <Stack
    direction="column"
    spacing={1}
    data-test-id={LOADING_DOUGHNUT_WIDGET_TEST_ID}
    sx={{ p: 2, position: 'relative' }}
  >
    <Skeleton variant="text" height={30} width="100%" />

    <Stack direction="row" sx={{ justifyContent: 'center' }}>
      <Skeleton
        variant="circular"
        width={`${bigVersion ? 11.5 : 8.5}rem`}
        height={`${bigVersion ? 11.5 : 8.5}rem`}
        sx={{ flexShrink: 0 }}
      />
    </Stack>
    <Stack direction="row" sx={{ justifyContent: 'center' }}>
      <Skeleton variant="text" width="50%" />
    </Stack>
    {errorMsg && (
      <ErrorOverlayWithRefetchButton errorMsg={errorMsg} refetch={refetch} />
    )}
  </Stack>
);

export default DoughnutSkeleton;
